import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trust from "./components/Trust";
import Problem from "./components/Problem";
import Services from "./components/Services";
import Benefits from "./components/Benefits";
import Process from "./components/Process";
import ForAgencies from "./components/ForAgencies";
import ForOwners from "./components/ForOwners";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const HomePage = () => (
  <div data-testid="next-room-home" className="bg-white">
    <Navbar />
    <main>
      <Hero />
      <Trust />
      <Problem />
      <Services />
      <Benefits />
      <Process />
      <ForAgencies />
      <ForOwners />
      <About />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: "Inter, sans-serif",
            borderRadius: "12px",
            border: "1px solid #EAEAEA",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
